<template>
  <div class="login">
    <div class="d-flex align-center justify-center h-screen">
      <div class="form-container">
        <div class="title">
          <h2>{{ $t("login.title") }}</h2>
        </div>
        <v-form fast-fail @submit.prevent="login" class="login-form">
          <v-text-field
            v-model="email"
            :label="$t('login.email')"
          ></v-text-field>
          <v-text-field
            v-model="password"
            :label="$t('login.password')"
            @click:append-inner="showPassword = !showPassword"
            :append-inner-icon="showPassword ? 'ti ti-eye-closed' : 'ti ti-eye'"
            :type="showPassword ? 'text' : 'password'"
          ></v-text-field>
          <div class="btn-row">
            <v-btn
              class="reset-pwd-btn"
              variant="text"
              @click="resetPassword()"
              >{{ $t("login.resetPwd") }}</v-btn
            >
            <v-btn
              type="submit"
              class="login-btn"
              :disabled="email == '' || password == ''"
              >{{ $t("login.signIn") }}</v-btn
            >
          </div>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      email: "",
      password: "",
      showPassword: false,
    };
  },
  methods: {
    ...mapActions({
      loginUser: "users/loginUser",
    }),
    login() {
      const payload = {
        email: this.email,
        password: this.password,
      };
      this.loginUser(payload)
        .then(() => {
          location.href = "/";
        })
        .catch((err) => {
          console.error(err);
        });
    },
    resetPassword() {
      this.$router.push({ path: "/forgot-password" });
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  .form-container {
    background-color: white;
    padding: 32px 16px;
    border-radius: 8px;
    width: 520px;
    box-shadow: 0px 3px 5px 1px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0px 3px 5px 1px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: 0px 3px 5px 1px rgba(0, 0, 0, 0.3);
  }
  .title {
    text-align: center;
    padding: 8px 32px;
    background-color: #ae2f27;
    color: #fff;
    border-radius: 8px;
    margin: -60px auto 0 auto;
    width: fit-content;
  }
  .login-form {
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    ::v-deep .v-field {
      padding-right: 0px;
    }
    ::v-deep .v-field__append-inner {
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
      i {
        opacity: 1;
        &.ti:before {
          font-family: "tabler-icons" !important;
          color: #bebebf;
        }
      }
    }
  }
  .btn-row {
    display: flex;
    justify-content: space-between;
    .login-btn {
      background: #ae2f27;
      color: #fff;
      max-width: 300px;
      padding: 8px 32px;
    }
  }
}

@media (max-width: 756px) {
  .login {
    .form-container {
      width: unset;
    }
    .btn-row {
      flex-direction: column;
      justify-content: space-around;
      gap: 12px;
    }
  }
}
</style>
